(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bluvabottimeline"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initTimeline = (section) => {
      if (!section || section.dataset.timelineReady === 'true') return;

      const scrollContainer = section.querySelector('[data-timeline-scroll]');
      const items = [...section.querySelectorAll('[data-timeline-item]')];
      const backgrounds = [...section.querySelectorAll('[data-timeline-background]')];
      const progressDots = [...section.querySelectorAll('[data-timeline-progress]')];
      const liquidIndicators = [...section.querySelectorAll('[data-timeline-liquid]')];

      if (!scrollContainer || !items.length) return;

      section.dataset.timelineReady = 'true';

      const mobileQuery = window.matchMedia('(max-width: 749px)');
      let ticking = false;
      let activeIndex = 0;

      const setActiveIndex = (index) => {
        if (index === activeIndex) return;

        activeIndex = index;
        items.forEach((item, itemIndex) => {
          const isActive = itemIndex === activeIndex;
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-hidden', String(!isActive));
        });
        backgrounds.forEach((background, backgroundIndex) => {
          background.classList.toggle('is-active', backgroundIndex === activeIndex);
        });
        progressDots.forEach((dot, dotIndex) => {
          dot.classList.toggle('is-active', dotIndex === activeIndex);
        });
      };

      const update = () => {
        ticking = false;

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        const bounds = scrollContainer.getBoundingClientRect();
        const range = Math.max(scrollContainer.offsetHeight - window.innerHeight, 1);
        const travelled = Math.min(range, Math.max(0, -bounds.top));
        const progress = travelled / range;
        const isMobile = mobileQuery.matches;
        const maxStage = Math.max(items.length - 1, 0);
        const rawStage = progress * maxStage;
        const baseStage = Math.min(Math.floor(rawStage), Math.max(maxStage - 1, 0));
        const localStage = maxStage === 0 ? 0 : rawStage - baseStage;
        const holdRatio = isMobile ? 0.38 : 0.52;
        const transitionRatio = localStage <= holdRatio ? 0 : (localStage - holdRatio) / (1 - holdRatio);
        const easedTransition = transitionRatio * transitionRatio * (3 - 2 * transitionRatio);
        const stage = maxStage === 0 ? 0 : baseStage + easedTransition;
        const depth = isMobile ? 680 : 1420;
        const horizontalOffset = isMobile ? 48 : Math.max(540, window.innerWidth * 0.58);
        const desktopEnterOffset = Math.max(260, window.innerWidth * 0.28);
        const verticalOffset = isMobile ? 24 : 54;

        liquidIndicators.forEach((indicator) => {
          indicator.style.height = `${(progress * 100).toFixed(2)}%`;
        });

        items.forEach((item, index) => {
          const distance = index - stage;
          const absoluteDistance = Math.abs(distance);
          const motionDistance = Math.max(0, absoluteDistance - 0.12);
          const direction = index % 2 === 0 ? -1 : 1;
          const translateX = isMobile
            ? distance < 0
              ? direction * Math.min(motionDistance * horizontalOffset, horizontalOffset * 1.25)
              : direction * Math.min(motionDistance * horizontalOffset * 0.42, horizontalOffset * 0.42)
            : distance < 0
              ? direction * Math.min(motionDistance * horizontalOffset, horizontalOffset)
              : -direction * Math.min(motionDistance * desktopEnterOffset, desktopEnterOffset);
          const translateY = distance < 0 ? -Math.min(motionDistance * verticalOffset, verticalOffset) : 0;
          const translateZ = -Math.min(motionDistance * depth, depth * 1.45);
          const opacity = Math.max(0, Math.min(1, 1 - motionDistance * 0.84));
          const scale = Math.max(0.8, 1 - motionDistance * 0.1);
          const blur = Math.min(10, motionDistance * 6.4);

          item.style.opacity = opacity.toFixed(3);
          item.style.filter = blur > 0.5 ? `blur(${blur.toFixed(1)}px)` : 'none';
          item.style.transform = `translate3d(${translateX.toFixed(1)}px, ${translateY.toFixed(1)}px, ${translateZ.toFixed(1)}px) scale(${scale.toFixed(3)})`;
        });

        setActiveIndex(Math.max(0, Math.min(items.length - 1, Math.round(stage))));
      };

      const requestUpdate = () => {
        if (ticking) return;

        ticking = true;
        window.requestAnimationFrame(update);
      };

      window.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', requestUpdate, { passive: true });
      mobileQuery.addEventListener('change', requestUpdate);
      requestUpdate();
    };

    const initAllTimelines = (root = document) => {
      if (root.matches && root.matches('[data-brand-story-timeline]')) {
        initTimeline(root);
      }

      root.querySelectorAll('[data-brand-story-timeline]').forEach(initTimeline);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAllTimelines(), { once: true });
    } else {
      initAllTimelines();
    }

    document.addEventListener('shopify:section:load', (event) => initAllTimelines(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
